import { Title } from "rizzui";
import cn from "@/utils/class-names";
import { Order, User } from "@/types";
import { HOST_API_URL } from "config";
import ImageViewer from "./imageViewer";
import { useModal } from "../../modal-views/use-modal";

interface AddressesProps {
    order: Order;
}

export default function FooterSection({ order }: AddressesProps) {
    const { openModal } = useModal();
    const productImagePath = order?.product?.imagePath
        ?.replace("wwwroot/", "")
        .replace(/\\/g, "/");
    const productImageUrl = productImagePath
        ? `${HOST_API_URL.replace("/api", "/")}${productImagePath}`
        : "";

    const handleImageClick = () => {
        if (!productImageUrl) return;

        openModal({
            view: (
                <ImageViewer
                    path={productImageUrl}
                    onClose={() => {}}
                />
            ),
            customSize: "850px",
        });
    };

    return (
        <div className={cn("grid gap-6 @2xl:grid-cols-2 @3xl:gap-10")}>
            <AddressCard title="Customer Information" userInfo={order.client} />

            <div
                className={cn(
                    "border border-muted rounded p-3 sm:p-4",
                )}
            >
                {productImageUrl ? (
                    <div className="mx-auto w-full max-w-[520px] overflow-hidden rounded-lg border border-gray-100 bg-white shadow-sm">
                        <img
                            src={productImageUrl}
                            alt={order?.product?.name || "Product image"}
                            className="h-[260px] w-full object-contain p-2 sm:h-[320px] md:h-[360px] cursor-pointer transition-shadow hover:shadow-lg hover:shadow-gray-500/40"
                            onClick={handleImageClick}
                        />
                    </div>
                ) : (
                    <div className="flex h-[260px] items-center justify-center rounded-lg border border-dashed border-muted-foreground/30 text-sm text-gray-500 sm:h-[320px]">
                        No product image available
                    </div>
                )}
            </div>
        </div>
    );
}

function AddressCard({
    title,
    className,
    userInfo,
}: {
    title: string;
    className?: string;
    userInfo: User;
}) {
    return (
        <div
            className={cn(
                "rounded-lg border border-gray-300 p-5 @3xl:p-7 bg-white shadow-sm",
                className,
            )}
        >
            <Title
                as="h3"
                className="text-base font-semibold sm:text-lg text-gray-800"
            >
                {title}
            </Title>
            <ul className="mt-4 grid gap-3 @3xl:mt-5">
                <li className="flex items-center gap-1">
                    <span className="font-semibold text-gray-900">
                        Fullname :
                    </span>
                    <span>{userInfo?.fullname}</span>
                </li>
                <li className="flex items-center gap-1">
                    <span className="font-semibold text-gray-900">Email :</span>
                    <span>{userInfo?.email.toLowerCase()}</span>
                </li>
                <li className="flex items-center gap-1">
                    <span className="font-semibold text-gray-900">Phone :</span>
                    <span>{userInfo?.phoneNumber}</span>
                </li>              
            </ul>
        </div>
    );
}
